module.exports = __webpack_public_path__ + "img/08-cross.6f682039.svg";